import { i18n } from '@zet/localization'

import en from './en.json'
import hi from './hi.json'

const localizationObj = {
  en,
  hi,
}

i18n.store(localizationObj)
i18n.defaultLocale = 'en'

// TODO: Need to remove brandsI18n export after removing all references to it
export { i18n as brandsI18n, i18n }
